import { useMemo } from 'react';

import { IMAGE_SIZE } from '@services/images/constants';
import getImageMenuSection from '@services/images/getImageMenuSection';
import useScreenWidthImage from './useScreenWidthImage';

const DESKTOP_COLUMNS_LAYOUT = 3;

function useMenuSectionImage({
  image,
  size = IMAGE_SIZE.FULL,
  height,
  country,
  isDesktopLayout,
}) {
  const screenWidth = useScreenWidthImage({ size });
  const width = isDesktopLayout
    ? screenWidth / DESKTOP_COLUMNS_LAYOUT
    : screenWidth;

  const src = useMemo(
    () => (width ? getImageMenuSection({ image, width, height, country }) : ''),
    [image, width, height, country],
  );

  return src;
}

export default useMenuSectionImage;
